import { render, staticRenderFns } from "./MultipleChoiceTextQuestionTextImageAnswer.vue?vue&type=template&id=1e452f7f"
import script from "./MultipleChoiceTextQuestionTextImageAnswer.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceTextQuestionTextImageAnswer.vue?vue&type=script&lang=js"
import style0 from "./MultipleChoiceTextQuestionTextImageAnswer.vue?vue&type=style&index=0&id=1e452f7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports